import request from "../services/HTTPClient";
import { requestMethods, API } from "../constants";

// Helper function to safely build the URL
const buildUrl = (base, page, startDate, endDate, search, buyerId, sellerId) => {
  let url = `${base}?page=${page}`;
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (search) url += `&search=${search}`;
  if (buyerId && buyerId !== 'all') url += `&buyerId=${buyerId}`;
  if (sellerId && sellerId !== 'all') url += `&sellerId=${sellerId}`;
  return url;
};

// Helper function to safely build the filter URL
const buildFilterUrl = (base, status, page, startDate, endDate, search, buyerId, sellerId) => {
  let url = `${base}?page=${page}`;
  if (status && status !== 'all') {
    url += `&status=${status}`;
  }
  if (startDate) url += `&start_date=${startDate}`;
  if (endDate) url += `&end_date=${endDate}`;
  if (search) url += `&search=${search}`;
  if (buyerId && buyerId !== 'all') url += `&buyerId=${buyerId}`;
  if (sellerId && sellerId !== 'all') url += `&sellerId=${sellerId}`;
  return url;
};


const OrderService = (function () {
  const _service = {

    //================================================================================
    // General & Paginated Order Retrieval
    //================================================================================

    ViewServices: function (page = 1, startDate, endDate, search, buyerId, sellerId) {
      return request({
        url: buildUrl(API.ORDERS.FILTER, page, startDate, endDate, search, buyerId, sellerId),
        method: requestMethods.GET,
      });
    },
    
    FilterServices: function (status, page = 1, startDate, endDate, search, buyerId, sellerId) {
      return request({
        url: buildFilterUrl(API.ORDERS.FILTER, status, page, startDate, endDate, search, buyerId, sellerId),
        method: requestMethods.GET,
      });
    },

    GetNewOrders: function (page = 1, startDate, endDate, search, buyerId, sellerId) {
        return request({
            url: buildUrl(API.ORDERS.NEW, page, startDate, endDate, search, buyerId, sellerId),
            method: requestMethods.GET,
        });
    },

    GetAllOrders: function (page = 1, startDate, endDate, search, buyerId, sellerId) {
        return request({
            url: buildUrl(API.ORDERS.ALL, page, startDate, endDate, search, buyerId, sellerId),
            method: requestMethods.GET,
        });
    },

    GetFinishedServices: function (page = 1, startDate, endDate, search, buyerId, sellerId) {
        return request({
            url: buildUrl(API.ORDERS.FINISHED, page, startDate, endDate, search, buyerId, sellerId),
            method: requestMethods.GET,
        });
    },

    GetCanceledServices: function (page = 1, startDate, endDate, search, buyerId, sellerId) {
        return request({
            url: buildUrl(API.ORDERS.CANCELED, page, startDate, endDate, search, buyerId, sellerId),
            method: requestMethods.GET,
        });
    },

    GetQuoteServices: function (page = 1, startDate, endDate, search, buyerId, sellerId) {
        return request({
            url: buildUrl(API.ORDERS.QUOTE, page, startDate, endDate, search, buyerId, sellerId),
            method: requestMethods.GET,
        });
    },

    GetBuildServices: function (page = 1, startDate, endDate, search, buyerId, sellerId) {
        return request({
            url: buildUrl(API.ORDERS.BUILD, page, startDate, endDate, search, buyerId, sellerId),
            method: requestMethods.GET,
        });
    },

    GetTogoServices: function (page = 1, startDate, endDate, search, buyerId, sellerId) {
        return request({
            url: buildUrl(API.ORDERS.TOGO, page, startDate, endDate, search, buyerId, sellerId),
            method: requestMethods.GET,
        });
    },

    GetReviewServices: function (page = 1, startDate, endDate, search, buyerId, sellerId) {
        return request({
            url: buildUrl(API.ORDERS.REVIEW, page, startDate, endDate, search, buyerId, sellerId),
            method: requestMethods.GET,
        });
    },

    GetAproveServices: function (page = 1, startDate, endDate, search, buyerId, sellerId) {
        return request({
            url: buildUrl(API.ORDERS.APROVE, page, startDate, endDate, search, buyerId, sellerId),
            method: requestMethods.GET,
        });
    },

    OpenOrders: function() {
        return request({
            url: API.ORDERS.OPEN,
            method: requestMethods.GET,
        });
    },

    //================================================================================
    // Order Management
    //================================================================================

    NewOrder: function(body) {
        return request({
            url: API.ORDERS.NEW,
            method: requestMethods.POST,
            data: body
        });
    },

    Update: function(id, body) {
        return request({
            url: API.ORDERS.UPDATE.concat(id),
            method: requestMethods.PUT,
            data: body
        });
    },
    
    All: function(){
      return request({
        url: API.ORDERS.ALL,
        method: requestMethods.GET,
      });
    },
    
    GetOrdersByUser: function(user_id) {
        return request({
            url: API.ORDERS.GET_BY_USER.concat(user_id),
            method: requestMethods.GET,
        });
    },
    
    GetOrderById: function(order_id) {
        return request({
            url: API.ORDERS.GET_BY_ID.concat(order_id),
            method: requestMethods.GET,
        });
    },
    
    OrderDetailsOLD: function(request_body) {
        return request({
            url: API.ORDERS.DETAILS.concat(request_body),
            method: requestMethods.GET,
        });
    },

    //================================================================================
    // Order Proposals (Apply to Order)
    //================================================================================
    
    Apply: function(data) {
        return request({
            url: API.ORDERS.APPLY.NEW,
            method: requestMethods.POST,
            data: data
        });
    },
    
    UpdateProposal: function(proposal_id, data) {
        return request({
            url: API.ORDERS.APPLY.UPDATE.concat(proposal_id),
            method: requestMethods.PUT,
            data: data
        });
    },
    
    DeleteProposal: function(data) {
        return request({
            url: API.ORDERS.APPLY.DELETE,
            method: requestMethods.DELETE,
            data: data
        });
    },
    
    GetAllProposals: function() {
        return request({
            url: API.ORDERS.APPLY.GET_ALL,
            method: requestMethods.GET,
        });
    },
    
    GetProposalsByOrder: function(order_id) {
        return request({
            url: API.ORDERS.APPLY.GET_BY_ORDER.concat(order_id),
            method: requestMethods.GET,
        });
    },
    
    GetProposalsBySupplier: function(supplier_id) {
        return request({
            url: API.MARKETPLACE.ORDERS.GET_BY_SUPPLIER.concat(supplier_id),
            method: requestMethods.GET,
        });
    },

    //================================================================================
    // Subservices and Bidding
    //================================================================================

    AddSubservice: function(request_body) {
        return request({
            url: API.ORDERS.SUBSERVICES.ADD,
            method: requestMethods.POST,
            data: {
                option: request_body.option,
                service: request_body.details.service,
                subservices: request_body.subservices,
            },
        });
    },

    RecommendedSuppliers: function(request_body) {
        return request({
            url: API.ORDERS.SUPPLIERS.GET_RECOMMENDED,
            method: requestMethods.POST,
            data: {
                service: request_body.service,
                subservice: request_body.subservice,
                categoria: request_body.categoria,
                order_id: request_body.order_id,
            },
        });
    },

    AddSuppliersToSubservice: function(request_body) {
        return request({
            url: API.ORDERS.SUPPLIERS.ADD_SUPPLIERS_TO_SUBSERVICE,
            method: requestMethods.POST,
            data: {
                service: request_body.service,
                subservice: request_body.subservice,
                values: request_body.values,
            },
        });
    },

    RejectBidding: function(request_body) {
        return request({
            url: API.ORDERS.SUPPLIERS.REJECT_BIDDINGS,
            method: requestMethods.POST,
            data: {
                service: request_body.service,
                subservice: request_body.subservice,
                comentario: request_body.comentario,
                client_vs: request_body.client_vs,
                client_org_id: request_body.client_org_id,
                created_at: request_body.created_at,
                order_id: request_body.order_id,
                type_code: request_body.type_code,
                service_title: request_body.service_title,
            },
        });
    },
    
    AcceptOrReject: function(request_body) {
        return request({
            url: API.ORDERS.SUBSERVICES.ACCEPT_OR_REJECT,
            method: requestMethods.POST,
            data: {
                check: request_body.check,
                supplier_id: request_body.supplier,
                subservice_id: request_body.subservice,
                service_id: request_body.service,
            },
        });
    },

    AcceptSubserviceList: function(request_body) {
        return request({
            url: API.ORDERS.SUBSERVICES.ACCEPT_SUBSERVICE_LIST.concat(
                "/",
                request_body.service
            ),
            method: requestMethods.GET,
        });
    },

    //================================================================================
    // Service Management (Maypretec)
    //================================================================================

    NewService: function(body) {
        return request({
            url: API.ORDERS.SERVICES.NEW_SERVICE,
            method: requestMethods.POST,
            data: body
        });
    },

    ServiceDetails: function(request_body) {
        return request({
            url: API.ORDERS.SERVICES.DETAILS.concat(request_body),
            method: requestMethods.GET,
        });
    },

    UpdateService: function(body) {
        return request({
            url: API.ORDERS.SERVICES.UPDATE,
            method: requestMethods.POST,
            data: body
        });
    },
    
    UpdateServiceInfo: function(request_body) {
        return request({
            url: API.ORDERS.SERVICES.CHANGE_INFO,
            method: requestMethods.POST,
            data: {
                client_info: request_body.client_info,
                service_info: request_body.service_info,
                subservice_id: request_body.subservice_id,
            },
        });
    },

    UpdateServicePlacement: function(body) {
        return request({
            url: API.ORDERS.SERVICES.UPDATE_PLACEMENT,
            method: requestMethods.POST,
            data: body
        });
    },

    GetServicesByCategory: function(body){
        return request({
            url: API.ORDERS.SERVICES.GET_BY_CATEGORY,
            method: requestMethods.POST,
            data: body
        })
    },

    GetByCategory: function(cat){
        return request({
            url: API.ORDERS.GET_BY_CATEGORY.concat(cat),
            method: requestMethods.GET,
        });
    },
    
    GeneralServices: function(request_body) {
        return request({
            url: API.ORDERS.SERVICES.GENERAL_SERVICES,
            method: requestMethods.POST,
            data: {
                fileList: request_body.fileList,
                title: request_body.title,
                description: request_body.description,
                time: request_body.time,
            },
        });
    },

    ApplyService: function(body) {
        return request({
            url: API.ORDERS.SERVICES.APPLY,
            method: requestMethods.POST,
            data: body
        });
    },

    GetProposalByService: function(body) {
        return request({
            url: API.ORDERS.SERVICES.GET_PROP_SERVICE,
            method: requestMethods.POST,
            data: body
        });
    },

    GetProposalByUser: function(body) {
        return request({
            url: API.ORDERS.SERVICES.GET_PROP_USER,
            method: requestMethods.POST,
            data: body
        });
    },

    ChooseProposal: function(body) {
        return request({
            url: API.ORDERS.SERVICES.CHOOSE_PROPOSAL,
            method: requestMethods.POST,
            data: body
        });
    },

    //================================================================================
    // Steps, Status & Comments
    //================================================================================
    
    ChangeServiceStep: function(request_body) {
        return request({
            url: API.ORDERS.SERVICES.CHANGE_STEP,
            method: requestMethods.POST,
            data: {
                service: request_body.service,
                step: request_body.step,
            },
        });
    },
    
    ChangeStep: function(request_body) {
        return request({
            url: API.ORDERS.SUBSERVICES.CHANGE_STEP,
            method: requestMethods.POST,
            data: request_body,
        });
    },

    SendOrderComment: function(request_body) {
        return request({
            url: API.ORDERS.COMMENTS.SEND,
            method: requestMethods.POST,
            data: request_body,
        });
    },
    
    //================================================================================
    // Quoting & Purchase Orders (PO)
    //================================================================================

    AddRequest: function(request_body) {
        return request({
            url: API.ORDERS.ADD_REQUEST,
            method: requestMethods.POST,
            data: request_body,
        });
    },

    UploadQuote: function(request_body) {
        return request({
            url: API.ORDERS.AGENTS.UPLOAD_QUOTE,
            method: requestMethods.POST,
            data: request_body,
        });
    },

    QuoteAgain: function(request_body) {
        return request({
            url: API.ORDERS.SUPPLIERS.QUOTE_AGAIN,
            method: requestMethods.POST,
            data: {
                supplier: request_body.supplier,
                service: request_body.service,
                subservice: request_body.subservice,
            },
        });
    },

    UploadIndustryPO: function(body) {
        return request({
            url: API.ORDERS.SERVICES.UPLOAD_INDUSTRY_PO,
            method: requestMethods.POST,
            data: body
        });
    },

    UploadSupplierPO: function(body) {
        return request({
            url: API.ORDERS.SERVICES.UPLOAD_SUPPLIER_PO,
            method: requestMethods.POST,
            data: body
        });
    },
    
    //================================================================================
    // Logs & Other Actions
    //================================================================================

    GetOrderLogs: function() {
        return request({
            url: API.ORDERS.APPLY.GET_ALL, // Note: This was the original URL in the provided code
            method: requestMethods.GET,
        });
    },
    
    ServiceLogs: function(body) {
        return request({
            url: API.ORDERS.SERVICES.SERVICE_LOGS.concat(body),
            method: requestMethods.GET,
        });
    },

    OrderLogs: function(id) {
        return request({
            url: API.ORDERS.LOGS.GET_BY_ORDER_ID.concat(id),
            method: requestMethods.GET,
        });
    },

    CancelRequest: function(request_body) {
        return request({
            url: API.ORDERS.SUPPLIERS.CANCEL_REQUEST,
            method: requestMethods.POST,
            data: {
                client_info: request_body.client_info,
                service_info: request_body.service_info,
                subservices: request_body.subservices,
                comentario: request_body.comentario,
                option: request_body.option.comentario,
            },
        });
    },

  };

  // Alias for backward compatibility from the new provided code
  _service.GetAll = _service.GetAllOrders;

  return _service;
})();

export default OrderService;
